// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.app__center {
  justify-content: center;
}

.app-content {
  width: 100%;
}

.app-header {
  display: flex;
  align-items: center;
  align-self: center;
  z-index: 10;
  padding: 2.5rem 2.5rem 0 2.5rem;
  flex-wrap: wrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-x: scroll;
  flex-wrap: nowrap;
  border-bottom: 2px solid rgb(47, 49, 141, 0.1);
  justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.24);
  -webkit-user-select: none;
          user-select: none;
}

.app-header::-webkit-scrollbar {
  display: none;
}

.app-header .form__radio-buttons,
.app-header .button {
  margin-bottom: 2.5rem;
}

.app-header__fixed {
  position: fixed;
  top: 0;
  width: 100%;
  -webkit-backdrop-filter: blur(70px);
          backdrop-filter: blur(70px);
}

.app-header--left,
.app-header--right,
.app-header--center {
  display: flex;
  width: 33.33%;
}

.app-header--left {
  justify-content: flex-start;
  margin-left: 6rem;
}
.app-header--right {
  justify-content: flex-end;
}
.app-header--center {
  justify-content: center;
}

@media only screen and (min-width: 0px) and (max-width: 550px) {
  .app-header {
    justify-content: initial;
  }
}

@media only screen and (min-width: 0px) and (max-width: 800px) {
  .app-header--left {
    margin-left: 0;
  }
  .is-desktop .app-header--left,
  .is-desktop .app-header--right,
  .is-desktop .app-header--center {
    width: initial;
  }
}

@media only screen and (min-width: 0px) and (max-width: 1000px) {
  .is-mobile .app-header--left,
  .is-mobile .app-header--right,
  .is-mobile .app-header--center {
    width: initial;
  }
}

/* MODAL */
.modal-transition,
.modal-transition .app-modal--container {
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
  perspective: 1000px;
  transform-style: preserve-3d;
}

.modal-transition {
  opacity: 0;
}

.modal-transition-enter,
.modal-transition-enter-done {
  opacity: 1;
}

.modal-transition .app-modal--container {
  transform: rotateX(-45deg) translateY(-40px) scale(0.9);
}

.modal-transition-exit .app-modal--container,
.modal-transition-exit-done .app-modal--container {
  transform: rotateX(0deg) scale(0.9);
}

.modal-transition-enter .app-modal--container,
.modal-transition-enter-done .app-modal--container {
  transform: rotateX(0deg) translateY(0px) scale(1);
}

.modal-transition-exit,
.modal-transition-exit-done {
  transition-duration: 0.2s;
  opacity: 0;
}

.app-modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9;
}

.app-modal .app-modal--container {
  max-width: 90vw;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 2rem;
  padding: 2rem;
  box-shadow: 0 1rem 4rem rgba(0, 0, 0, 0.2);
}

@media (min-width: 600px) {
  .app-modal .app-modal--container {
    max-width: 600px;
  }
}

.app-modal .app-modal--container-text {
  font-size: 12pt;
  padding: 2rem 2rem 3rem;
  max-height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.app-modal--container .button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.app-modal--container .button-container .button {
  flex-grow: 1;
}

.logo-container {
  position: fixed;
  top: 24px;
  left: 24px;
  z-index: 11;
}

.logo-source {
  width: 32px;
}

form {
  display: flex;
}

.form__radio-buttons {
  display: flex;
  flex-direction: column;
}

@media (max-width: 700px) {
  .logo-container {
    display: none;
  }
}

.label {
  font-size: 2rem;
  color: var(--tint-color);
  line-height: 1.1;
  display: grid;
  grid-template-columns: 1em auto;
  gap: 1rem;
  align-items: center;
  margin-left: 1rem;
  cursor: pointer;
}

.label:first-child {
  margin-bottom: 0.25rem;
}

input[type="radio"] {
  /* Add if not using autoprefixer */
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: transparent;
  /* Not removed via appearance */
  margin: 0;
  font: inherit;
  color: var(--tint-color);
  width: 2rem;
  height: 2rem;
  border: 0.25rem solid var(--tint-color);
  border-radius: 50%;
  display: grid;
  place-content: center;
  cursor: pointer;
}

input[type="radio"]::before {
  content: "";
  width: 0.5em;
  height: 0.5em;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--tint-color);
}

input[type="radio"] {
  text-decoration: underline;
}

input[type="radio"]:checked::before {
  transform: scale(0.75);
}

.radio-buttons__label-name {
  text-overflow: ellipsis;
  width: 12rem;
  overflow: hidden;
}

/* SWIPE */
html.game-swipe.type-a {
  background-color: var(--swipe-background-color);
  /*background-image: linear-gradient(45deg, rgba(221,137,160,1) 0%, rgba(253,241,227,1) 100%);*/
  background-repeat: no-repeat;
  background-attachment: fixed;
}
html.game-swipe.type-b {
  background-color: var(--swipe-background-color);
  /*background: linear-gradient(45deg, rgba(214,95,138,1) 0%, rgba(228,136,98,1) 100%);*/
  background-repeat: no-repeat;
  background-attachment: fixed;
}
html.game-swipe .app-header__fixed {
  background-color: rgba(255, 255, 255, 0.7);
  -webkit-backdrop-filter: blur(70px);
          backdrop-filter: blur(70px);
}

/* Rackare! */
html.game-rackare {
  background-color: var(--rackare-background-color);
}
html.game-rackare .app-header__fixed {
  background-color: rgba(255, 255, 255, 0.7);
  -webkit-backdrop-filter: blur(70px);
          backdrop-filter: blur(70px);
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,8CAA8C;EAC9C,uBAAuB;EACvB,kDAAkD;EAClD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;;;EAGE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;;;IAGE,cAAc;EAChB;AACF;;AAEA;EACE;;;IAGE,cAAc;EAChB;AACF;;AAEA,UAAU;AACV;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,uDAAuD;AACzD;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAElC,wCAAwC;EAExC,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,+BAA+B;EAC/B,SAAS;EACT,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,+CAA+C;EAC/C,8FAA8F;EAC9F,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,+CAA+C;EAC/C,sFAAsF;EACtF,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,0CAA0C;EAC1C,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,iDAAiD;AACnD;AACA;EACE,0CAA0C;EAC1C,mCAA2B;UAA3B,2BAA2B;AAC7B","sourcesContent":[".app {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.app__center {\n  justify-content: center;\n}\n\n.app-content {\n  width: 100%;\n}\n\n.app-header {\n  display: flex;\n  align-items: center;\n  align-self: center;\n  z-index: 10;\n  padding: 2.5rem 2.5rem 0 2.5rem;\n  flex-wrap: wrap;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  overflow-x: scroll;\n  flex-wrap: nowrap;\n  border-bottom: 2px solid rgb(47, 49, 141, 0.1);\n  justify-content: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.24);\n  user-select: none;\n}\n\n.app-header::-webkit-scrollbar {\n  display: none;\n}\n\n.app-header .form__radio-buttons,\n.app-header .button {\n  margin-bottom: 2.5rem;\n}\n\n.app-header__fixed {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  backdrop-filter: blur(70px);\n}\n\n.app-header--left,\n.app-header--right,\n.app-header--center {\n  display: flex;\n  width: 33.33%;\n}\n\n.app-header--left {\n  justify-content: flex-start;\n  margin-left: 6rem;\n}\n.app-header--right {\n  justify-content: flex-end;\n}\n.app-header--center {\n  justify-content: center;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 550px) {\n  .app-header {\n    justify-content: initial;\n  }\n}\n\n@media only screen and (min-width: 0px) and (max-width: 800px) {\n  .app-header--left {\n    margin-left: 0;\n  }\n  .is-desktop .app-header--left,\n  .is-desktop .app-header--right,\n  .is-desktop .app-header--center {\n    width: initial;\n  }\n}\n\n@media only screen and (min-width: 0px) and (max-width: 1000px) {\n  .is-mobile .app-header--left,\n  .is-mobile .app-header--right,\n  .is-mobile .app-header--center {\n    width: initial;\n  }\n}\n\n/* MODAL */\n.modal-transition,\n.modal-transition .app-modal--container {\n  transition-property: all;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-out;\n  perspective: 1000px;\n  transform-style: preserve-3d;\n}\n\n.modal-transition {\n  opacity: 0;\n}\n\n.modal-transition-enter,\n.modal-transition-enter-done {\n  opacity: 1;\n}\n\n.modal-transition .app-modal--container {\n  transform: rotateX(-45deg) translateY(-40px) scale(0.9);\n}\n\n.modal-transition-exit .app-modal--container,\n.modal-transition-exit-done .app-modal--container {\n  transform: rotateX(0deg) scale(0.9);\n}\n\n.modal-transition-enter .app-modal--container,\n.modal-transition-enter-done .app-modal--container {\n  transform: rotateX(0deg) translateY(0px) scale(1);\n}\n\n.modal-transition-exit,\n.modal-transition-exit-done {\n  transition-duration: 0.2s;\n  opacity: 0;\n}\n\n.app-modal {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 9;\n}\n\n.app-modal .app-modal--container {\n  max-width: 90vw;\n  background-color: rgba(255, 255, 255, 1);\n  border-radius: 2rem;\n  padding: 2rem;\n  box-shadow: 0 1rem 4rem rgba(0, 0, 0, 0.2);\n}\n\n@media (min-width: 600px) {\n  .app-modal .app-modal--container {\n    max-width: 600px;\n  }\n}\n\n.app-modal .app-modal--container-text {\n  font-size: 12pt;\n  padding: 2rem 2rem 3rem;\n  max-height: 60vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.app-modal--container .button-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n}\n\n.app-modal--container .button-container .button {\n  flex-grow: 1;\n}\n\n.logo-container {\n  position: fixed;\n  top: 24px;\n  left: 24px;\n  z-index: 11;\n}\n\n.logo-source {\n  width: 32px;\n}\n\nform {\n  display: flex;\n}\n\n.form__radio-buttons {\n  display: flex;\n  flex-direction: column;\n}\n\n@media (max-width: 700px) {\n  .logo-container {\n    display: none;\n  }\n}\n\n.label {\n  font-size: 2rem;\n  color: var(--tint-color);\n  line-height: 1.1;\n  display: grid;\n  grid-template-columns: 1em auto;\n  gap: 1rem;\n  align-items: center;\n  margin-left: 1rem;\n  cursor: pointer;\n}\n\n.label:first-child {\n  margin-bottom: 0.25rem;\n}\n\ninput[type=\"radio\"] {\n  /* Add if not using autoprefixer */\n  -webkit-appearance: none;\n  /* Remove most all native input styles */\n  -moz-appearance: none;\n  appearance: none;\n  /* For iOS < 15 */\n  background-color: transparent;\n  /* Not removed via appearance */\n  margin: 0;\n  font: inherit;\n  color: var(--tint-color);\n  width: 2rem;\n  height: 2rem;\n  border: 0.25rem solid var(--tint-color);\n  border-radius: 50%;\n  display: grid;\n  place-content: center;\n  cursor: pointer;\n}\n\ninput[type=\"radio\"]::before {\n  content: \"\";\n  width: 0.5em;\n  height: 0.5em;\n  border-radius: 50%;\n  transform: scale(0);\n  transition: 120ms transform ease-in-out;\n  box-shadow: inset 1em 1em var(--tint-color);\n}\n\ninput[type=\"radio\"] {\n  text-decoration: underline;\n}\n\ninput[type=\"radio\"]:checked::before {\n  transform: scale(0.75);\n}\n\n.radio-buttons__label-name {\n  text-overflow: ellipsis;\n  width: 12rem;\n  overflow: hidden;\n}\n\n/* SWIPE */\nhtml.game-swipe.type-a {\n  background-color: var(--swipe-background-color);\n  /*background-image: linear-gradient(45deg, rgba(221,137,160,1) 0%, rgba(253,241,227,1) 100%);*/\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\nhtml.game-swipe.type-b {\n  background-color: var(--swipe-background-color);\n  /*background: linear-gradient(45deg, rgba(214,95,138,1) 0%, rgba(228,136,98,1) 100%);*/\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\nhtml.game-swipe .app-header__fixed {\n  background-color: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(70px);\n}\n\n/* Rackare! */\nhtml.game-rackare {\n  background-color: var(--rackare-background-color);\n}\nhtml.game-rackare .app-header__fixed {\n  background-color: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(70px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
